import type {Brand} from '@Components/mystuff-brands/brand-kits.types';
import {useAppSelector} from '@/hooks';

export const useBrandKitsFromStore = (): Brand[] => {
  return useAppSelector(({brands}) => {
    return brands.brands;
  });
};
